import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';

import StatusMessage from '../../util/StatusMessage'
import { TextField } from 'rmwc/TextField';

class AdminHallTicketUpload extends Component{

  constructor(props){
    super(props)
    this.state = {
      errorMsg: '',
      uploadDisabled: true,
      uploadStatusMessage: '',
      loading: false,
      data:{
      upload_file: ''
      },
      fileSize:{    
        fileMaxSize:10
        
      },
      formErrors:{
        fileError:''
      },
      paramsType: '',
      uploadType: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      paramsType: this.props.match.params.type,
      uploadType: this.props.match.params.uploadType
    })
  }

  handleSubmit(e) {
      e.preventDefault()
      const formData = new FormData(e.target);
      this.setState({uploadDisabled:true, uploadStatusMessage:'Upload in Progress. Please wait',loading: true,})
      if(this.state.uploadType === 'hallticket'){  
        api.uploadHallTicketExcel(this.props.user.accessToken,formData)
        .then((result) => {       
           if(result.status === 'success'){
            
            this.setState({uploadDisabled:false, uploadStatusMessage:'Upload Complete, Please Check logs',loading: false })

           }
           else{
            this.setState({uploadDisabled:true, uploadStatusMessage:'Upload Failed', loading: false});
          }
           
        })
        .catch((err) => {
        // console.log(`error:${err.stack}`)
          this.setState({ errorMsg: 'Error in Upload.', uploadDisabled:false, uploadStatusMessage:'',loading: false })
        })
      }

      else if(this.state.uploadType === 'tqReport'){
        api.uploadTqScoreReportExcel(this.props.user.accessToken, formData)
        .then((result) => {       
           if(result.status === 'success'){
            
            this.setState({uploadDisabled:false, uploadStatusMessage:'Upload Complete, Please Check logs',loading: false })

           }
           else if(result.status === 'error'){
            this.setState({errorMsg: result.message, uploadStatusMessage:'Upload Failed', loading: false})
           }

           else{
            this.setState({uploadDisabled:true, uploadStatusMessage:'Upload Failed', loading: false});
          }
           
        })
        .catch((err) => {
        // console.log(`error:${err.stack}`)
          this.setState({ errorMsg: 'Error in Upload.', uploadDisabled:false, uploadStatusMessage:'',loading: false })
        })
      }

      else if(this.state.uploadType === 'userImport'){
        api.uploadUserImportExcel(this.props.user.accessToken, formData)
        .then((result) => {       
           if(result.status === 'success'){
            
            this.setState({uploadDisabled:false, uploadStatusMessage:'Upload Complete, Please Check logs',loading: false })

           }
           else if(result.status === 'error'){
            this.setState({errorMsg: result.message, uploadStatusMessage:'Upload Failed', loading: false})
           }

           else{
            this.setState({uploadDisabled:true, uploadStatusMessage:'Upload Failed', loading: false});
          }
           
        })
        .catch((err) => {
        // console.log(`error:${err.stack}`)
          this.setState({ errorMsg: 'Error in Upload.', uploadDisabled:false, uploadStatusMessage:'',loading: false })
        })
      }

       else if(this.state.uploadType === 'seminarUserImport'){
        api.uploadSeminarImportExcel(this.props.user.accessToken, formData)
        .then((result) => {       
           if(result.status === 'success'){
            
            this.setState({uploadDisabled:false, uploadStatusMessage:'Upload Complete, Please Check logs',loading: false })

           }
           else if(result.status === 'error'){
            this.setState({errorMsg: result.message, uploadStatusMessage:'Upload Failed', loading: false})
           }

           else{
            this.setState({uploadDisabled:true, uploadStatusMessage:'Upload Failed', loading: false});
          }
           
        })
        .catch((err) => {
        // console.log(`error:${err.stack}`)
          this.setState({ errorMsg: 'Error in Upload.', uploadDisabled:false, uploadStatusMessage:'',loading: false })
        })
      }
      else if(this.state.uploadType === 'nationalAvgImport'){
        api.uploadNationalAverageImport(this.props.user.accessToken, formData)
        .then((result) => {       
           if(result.status === 'success'){
            
            this.setState({uploadDisabled:false, uploadStatusMessage:'Upload Complete, Please Check logs',loading: false })

           }
           else if(result.status === 'error'){
            this.setState({errorMsg: result.message, uploadStatusMessage:'Upload Failed', loading: false})
           }

           else{
            this.setState({uploadDisabled:true, uploadStatusMessage:'Upload Failed', loading: false});
          }
           
        })
        .catch((err) => {
        // console.log(`error:${err.stack}`)
          this.setState({ errorMsg: 'Error in Upload.', uploadDisabled:false, uploadStatusMessage:'',loading: false })
        })
      }

    }

  onInputChange = evt => {

    if(evt.target.files[0] === undefined)
      return
    
    let fileSize = evt.target.files[0].size/1024/1024;
    let file_name = evt.target.files[0].name;
    let file_type = evt.target.files[0].type;


    let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();

    if(fileSize < this.state.fileSize.fileMaxSize){
      if (extension == "xlsx" || extension == "xls"){
         const formErrors = Object.assign({}, this.state.formErrors);
        formErrors.fileError =''
        this.setState({uploadDisabled: false, formErrors: formErrors, uploadStatusMessage: ''})
      }
      else{
        const formErrors = Object.assign({}, this.state.formErrors);
        formErrors.fileError ='Invalid file format. Please check'
        this.setState({formErrors: formErrors, uploadDisabled:true, uploadStatusMessage: ''})
      }

    }
    else{
      const formErrors = Object.assign({}, this.state.formErrors);
      formErrors.fileError ='File Size exceeds maximum limit of ' + this.state.fileSize.fileMaxSize + ' MB'
      this.setState({formErrors: formErrors, uploadDisabled:true, uploadStatusMessage: ''})
    }

      const data = Object.assign({}, this.state.data);
      data[evt.target.name] = evt.target.value;
      this.setState({data});
  };

  handleGoBack = () => {
    if(this.state.uploadType === 'hallticket'){
      this.props.history.push(`/portal/app/admin/hallticket`)
    }
    else if (this.state.uploadType === 'tqReport'){
      this.props.history.push(`/portal/app/admin/tq/reports/home`)
    }
    else if (this.state.uploadType === 'userImport'){
      this.props.history.push(`/portal/app/admin/user/import/home`)
    }
    else if (this.state.uploadType === 'seminarUserImport'){
      this.props.history.push(`/portal/app/admin/seminar/list`)
    }
    else if (this.state.uploadType === 'nationalAvgImport'){
      this.props.history.push(`/portal/app/admin/tq/reports/home`)
    }
  }

  render() {

    let uploadButtonComponent
    if(!this.state.uploadDisabled){
      uploadButtonComponent = <Button raised>Upload</Button>
    }
    else{
      uploadButtonComponent = <Button disabled raised>Upload</Button>
    } 
    let headingComponent;
    if(this.state.paramsType === 'new' && this.state.uploadType === 'hallticket') {
      headingComponent = (
          <GridCell span="10">
            <Typography use="headline5">Upload Excel file for Hall Ticket Generation </Typography>
          </GridCell>
      )
    }
    else if (this.state.paramsType === 'update' && this.state.uploadType === 'hallticket') {
      headingComponent = (
        <GridCell span="10">
          <Typography use="headline5">Upload Excel file to update existing Hall Ticket details.</Typography>
        </GridCell>
      )
    }

    else if(this.state.paramsType === 'new' && this.state.uploadType === 'tqReport'){
      headingComponent = (
        <GridCell span="10">
          <Typography use="headline5">Upload Excel file to import TQ Report Scores.</Typography>
        </GridCell>
      )
    }

    else if(this.state.paramsType === 'new' && this.state.uploadType === 'userImport'){
      headingComponent = (
        <GridCell span="10">
          <Typography use="headline5">Upload Excel file for User Upload.</Typography>
        </GridCell>
      )
    }

    else if(this.state.paramsType === 'new' && this.state.uploadType === 'seminarUserImport'){
      headingComponent = (
        <GridCell span="10">
          <Typography use="headline6">Upload Excel file to import Users who have attended the Seminar</Typography>
        </GridCell>
      )
    }

     else if(this.state.paramsType === 'new' && this.state.uploadType === 'nationalAvgImport'){
      headingComponent = (
        <GridCell span="10">
          <Typography use="headline6">Upload Excel file to import National Average Scores</Typography>
        </GridCell>
      )
    }


    let loadingComponent
      if(this.state.loading){
        loadingComponent = (
            <div className="loader-component">
              <div className="loader"></div>
              <h4> Excel is getting uploaded. Please wait</h4>
            </div>
          )
      }
    
    return (
      <Grid>
        <GridCell span="12">
          <form  onSubmit={this.handleSubmit} style={{width: '100%'}}>
            <Card style={{padding: '25px'}}>
             <Grid className="opportunity-list-item">
              {headingComponent}
              <GridCell span="2">
                <Button onClick={this.handleGoBack}>BACK </Button>
              </GridCell>
              </Grid>
              <ListDivider/>
              <Grid className="opportunity-list-item">
                <GridCell span="5">
                  <input type="file" name="upload_file"  onChange={this.onInputChange} />
                </GridCell>

                <GridCell span="2">
                  {uploadButtonComponent}
                </GridCell>
                <GridCell span="5">
                  
                </GridCell>
                <GridCell span="2" className="button-section">
                  <TextField autoComplete="off" hidden name="nature_of_upload"  value={this.state.paramsType}/>
                </GridCell>
                 <GridCell span="12">
                  <Typography use="body2"><i>{this.state.uploadStatusMessage}</i></Typography>                  
                  <StatusMessage error_msg = {this.state.errorMsg}/>
                  <StatusMessage error_msg = {this.state.formErrors.fileError}/>
                </GridCell>
              </Grid>
              <ListDivider/>

              <GridCell span="12">
                <Typography use="body2"><b>Note:</b> <i>Choose a file and click on Upload to Upload the Excel file.</i></Typography>
              </GridCell>
              
            </Card>
          </form>
          {loadingComponent}
        </GridCell>
      </Grid>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminHallTicketUpload);


// WEBPACK FOOTER //
// ./src/views/admin/AdminHallTicketUpload.jsx